import '../css/app.scss';

import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';

/** Pages */
import Home from './pages/home';
import Standard from './pages/standard';

/** Transitions */
import DefaultTransition from './transitions/default';


/** Global Components */
import {gsap, scrollSmootherInstance} from './globals/gsap';
import Header from './globals/header';
import Footer from './globals/footer';

import Toplink from './components/toplink';
import PopUp from './components/popup';

const timeoutDuration = 2000;


$(() => {
	const $popup = $('[data-popup="el"]');
	let popup = null;
	if ($popup.length) {
		popup = new PopUp($popup);
	}

  barba.init({
		timeout: 30000,
		views: [Home, Standard],
		prevent: ({ el }) => {
			return (
				el.href.includes('#') ||
				el.href === window.location.href ||
				el.dataset.gallery === 'link'
			);
		},
		transitions: [DefaultTransition],
	});

	// init Footer Toplink
	const $toplink = $('.footer [data-toplink="el"]');

	if ($toplink.length) {
		new Toplink($toplink);
	}

	$('html').addClass('initted');
	$('html').removeClass('no-scroll');

	// check if cookie cc_cookie exists
	if(document.cookie.indexOf('cc_cookie') !== -1) {
		// cookie exists
		if(popup && sessionStorage.getItem('popup') !== 'shown') {
			setTimeout(() => {
				console.log('show popup');
				popup.show();
			}, timeoutDuration);
		}
	} else {
		console.log('cookie does not exist');
		window.addEventListener('cookieConsentFirstAction', () => {
			if(popup && sessionStorage.getItem('popup') !== 'shown') {
				setTimeout(() => {
					popup.show();
				}, timeoutDuration);
			}
		});
	}	
});

// window.addEventListener('load', () => {
// 	console.log('window loaded');

// 	// check for hash
// 	if (window.location.hash) {
// 		const hash = window.location.hash;

// 		if (hash) {
// 			scrollSmootherInstance.scrollTo(hash,true,'top 100px')
// 		}
// 	}
// });